/**
 * 与后端 ImportCellNormalize 一致：去 BOM、NBSP、零宽字符及首尾空白（学号、姓名等）。
 */
export function normalizeImportCell(val) {
  if (val == null) return '';
  return String(val)
    .replace(/^\uFEFF+|\uFEFF+$/g, '')
    .replace(/\u00A0/g, ' ')
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .trim();
}

/**
 * 是否展示「处理错误」入口：以下失败原因无行级错误明细或无法从原表回显，只能重新上传/新建任务。
 * 与后台 ImportOperationService / GetImportTaskErrors 行为保持一致。
 */
export function canShowImportErrorHandle(errorMessage) {
  const msg = (errorMessage == null ? '' : String(errorMessage)).trim();
  if (!msg) return true;
  if (msg.includes('导入文件物理路径解析失败或文件不存在')) return false;
  if (msg.includes('未读取到可用行')) return false;
  return true;
}
